import { XMarkIcon } from '@heroicons/react/24/outline';
import { useDetailsPaneClose } from './detailsPaneClose';

export function PaneCloseButton({ className = '' }: { className?: string }) {
    const close = useDetailsPaneClose();
    if (!close) return null;
    return (
        <button
            type="button"
            onClick={close}
            aria-label="Close details"
            className={`grid h-8 w-8 shrink-0 place-items-center rounded-lg text-gray-400 transition-colors hover:bg-gray-100 hover:text-gray-800 focus:outline-none focus-visible:ring-2 focus-visible:ring-gray-400 ${className}`}
        >
            <XMarkIcon className="h-4 w-4" aria-hidden="true" />
        </button>
    );
}
